/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { useMemo } from "react";
import { FieldDisplayWrapper } from "cms/fields/layout/field-display-wrapper";
import { useCurrentDynamicField } from "cms/fields/hooks/use-current-dynamic-field";
import { isArrayNotEmpty } from "utils/empty-exists";
import { EntityItemDisplay } from "./entity-item";

const EntityFieldDisplay = () => {
    
    const { field } = useCurrentDynamicField();
    const values = field?.values;
    
    return (
        <FieldDisplayWrapper>
            <div className='as-list-container'>
                {isArrayNotEmpty(values) &&
                    values.map((item, index) => {
                        const value = item?.value;
                        // const settings = item?.settings;
                        // const style = settings?.style;
                        // const format = settings?.format;
                        // const options = settings?.options;
                        return (
                            <EntityItemDisplay
                                key={index}
                                value={value}
                            />
                        );
                    })
                }
            </div>
        </FieldDisplayWrapper>
    );
};
EntityFieldDisplay.displayName = "EntityFieldDisplay";
export { EntityFieldDisplay };
